export default __webpack_public_path__ + "static/media/openInNew.3f3c8d06.svg";